import { CompanyIdHeader } from '@sit/core';
import { axiosInstance, buildHeaders, getToken } from '@sit/openapi';
import { getCompanyFromSessionStorage } from './utils/cross-platform-session-storage.js';
async function buildHeadersWithCompanyId(additionalHeaders, token) {
    const result = await getCompanyFromSessionStorage();
    const headers = result?.id
        ? { ...additionalHeaders, [CompanyIdHeader]: result.id }
        : additionalHeaders;
    return buildHeaders(headers, token);
}
async function interceptRequestSent(config) {
    const token = getToken();
    config.headers = await buildHeadersWithCompanyId(config.headers || {}, token);
    return config;
}
export function initializeAxiosRequestInterceptor() {
    axiosInstance.interceptors.request.use(interceptRequestSent, (error) => Promise.reject(error));
}
//# sourceMappingURL=axios.js.map